var map = {
	"./Gmmt_logo_sym_col.png": "./src/assets/images/Gmmt_logo_sym_col.png",
	"./common_ico_arrow_back.png": "./src/assets/images/common_ico_arrow_back.png",
	"./common_ico_arrow_back@2x.png": "./src/assets/images/common_ico_arrow_back@2x.png",
	"./common_ico_arrow_back@3x.png": "./src/assets/images/common_ico_arrow_back@3x.png",
	"./common_ico_dropdown_down_on.png": "./src/assets/images/common_ico_dropdown_down_on.png",
	"./common_ico_dropdown_down_on@2x.png": "./src/assets/images/common_ico_dropdown_down_on@2x.png",
	"./common_ico_dropdown_down_on@3x.png": "./src/assets/images/common_ico_dropdown_down_on@3x.png",
	"./common_ico_dropdown_up_on.png": "./src/assets/images/common_ico_dropdown_up_on.png",
	"./common_ico_dropdown_up_on@2x.png": "./src/assets/images/common_ico_dropdown_up_on@2x.png",
	"./common_ico_dropdown_up_on@3x.png": "./src/assets/images/common_ico_dropdown_up_on@3x.png",
	"./common_ico_hash.png": "./src/assets/images/common_ico_hash.png",
	"./common_ico_hash@2x.png": "./src/assets/images/common_ico_hash@2x.png",
	"./common_ico_hash@3x.png": "./src/assets/images/common_ico_hash@3x.png",
	"./common_ico_list_next.png": "./src/assets/images/common_ico_list_next.png",
	"./common_ico_list_next@2x.png": "./src/assets/images/common_ico_list_next@2x.png",
	"./common_ico_list_next@3x.png": "./src/assets/images/common_ico_list_next@3x.png",
	"./common_ico_list_prev.png": "./src/assets/images/common_ico_list_prev.png",
	"./common_ico_list_prev@2x.png": "./src/assets/images/common_ico_list_prev@2x.png",
	"./common_ico_list_prev@3x.png": "./src/assets/images/common_ico_list_prev@3x.png",
	"./common_ico_pop_complete.png": "./src/assets/images/common_ico_pop_complete.png",
	"./common_ico_pop_complete@2x.png": "./src/assets/images/common_ico_pop_complete@2x.png",
	"./common_ico_pop_complete@3x.png": "./src/assets/images/common_ico_pop_complete@3x.png",
	"./common_ico_pop_failed.png": "./src/assets/images/common_ico_pop_failed.png",
	"./common_ico_pop_failed@2x.png": "./src/assets/images/common_ico_pop_failed@2x.png",
	"./common_ico_pop_failed@3x.png": "./src/assets/images/common_ico_pop_failed@3x.png",
	"./common_ico_pop_loading.png": "./src/assets/images/common_ico_pop_loading.png",
	"./common_ico_pop_loading@2x.png": "./src/assets/images/common_ico_pop_loading@2x.png",
	"./common_ico_pop_loading@3x.png": "./src/assets/images/common_ico_pop_loading@3x.png",
	"./common_logo_horizontal_black.png": "./src/assets/images/common_logo_horizontal_black.png",
	"./common_logo_horizontal_black@2x.png": "./src/assets/images/common_logo_horizontal_black@2x.png",
	"./common_logo_horizontal_black@3x.png": "./src/assets/images/common_logo_horizontal_black@3x.png",
	"./ico_close_bl.png": "./src/assets/images/ico_close_bl.png",
	"./ico_close_bl@2x.png": "./src/assets/images/ico_close_bl@2x.png",
	"./ico_close_bl@3x.png": "./src/assets/images/ico_close_bl@3x.png",
	"./staking/sym_bnb.png": "./src/assets/images/staking/sym_bnb.png",
	"./staking/sym_bnb@2x.png": "./src/assets/images/staking/sym_bnb@2x.png",
	"./staking/sym_bnb@3x.png": "./src/assets/images/staking/sym_bnb@3x.png",
	"./staking/sym_btc.png": "./src/assets/images/staking/sym_btc.png",
	"./staking/sym_btc@2x.png": "./src/assets/images/staking/sym_btc@2x.png",
	"./staking/sym_btc@3x.png": "./src/assets/images/staking/sym_btc@3x.png",
	"./staking/sym_dai.png": "./src/assets/images/staking/sym_dai.png",
	"./staking/sym_dai@2x.png": "./src/assets/images/staking/sym_dai@2x.png",
	"./staking/sym_dai@3x.png": "./src/assets/images/staking/sym_dai@3x.png",
	"./staking/sym_eth.png": "./src/assets/images/staking/sym_eth.png",
	"./staking/sym_eth@2x.png": "./src/assets/images/staking/sym_eth@2x.png",
	"./staking/sym_eth@3x.png": "./src/assets/images/staking/sym_eth@3x.png",
	"./staking/sym_ivy.png": "./src/assets/images/staking/sym_ivy.png",
	"./staking/sym_ivy@2x.png": "./src/assets/images/staking/sym_ivy@2x.png",
	"./staking/sym_ivy@3x.png": "./src/assets/images/staking/sym_ivy@3x.png",
	"./staking/sym_mmt.png": "./src/assets/images/staking/sym_mmt.png",
	"./staking/sym_mmt@2x.png": "./src/assets/images/staking/sym_mmt@2x.png",
	"./staking/sym_mmt@3x.png": "./src/assets/images/staking/sym_mmt@3x.png",
	"./staking/sym_pancake.png": "./src/assets/images/staking/sym_pancake.png",
	"./staking/sym_pancake@2x.png": "./src/assets/images/staking/sym_pancake@2x.png",
	"./staking/sym_pancake@3x.png": "./src/assets/images/staking/sym_pancake@3x.png",
	"./staking/sym_usdc.png": "./src/assets/images/staking/sym_usdc.png",
	"./staking/sym_usdc@2x.png": "./src/assets/images/staking/sym_usdc@2x.png",
	"./staking/sym_usdc@3x.png": "./src/assets/images/staking/sym_usdc@3x.png",
	"./staking/sym_usdt.png": "./src/assets/images/staking/sym_usdt.png",
	"./staking/sym_usdt@2x.png": "./src/assets/images/staking/sym_usdt@2x.png",
	"./staking/sym_usdt@3x.png": "./src/assets/images/staking/sym_usdt@3x.png",
	"./staking/sym_xrp.png": "./src/assets/images/staking/sym_xrp.png",
	"./staking/sym_xrp@2x.png": "./src/assets/images/staking/sym_xrp@2x.png",
	"./staking/sym_xrp@3x.png": "./src/assets/images/staking/sym_xrp@3x.png",
	"./sym_metamask.png": "./src/assets/images/sym_metamask.png",
	"./sym_metamask@2x.png": "./src/assets/images/sym_metamask@2x.png",
	"./sym_metamask@3x.png": "./src/assets/images/sym_metamask@3x.png",
	"./sym_walletconnect.png": "./src/assets/images/sym_walletconnect.png",
	"./sym_walletconnect@2x.png": "./src/assets/images/sym_walletconnect@2x.png",
	"./sym_walletconnect@3x.png": "./src/assets/images/sym_walletconnect@3x.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive ^\\.\\/.*$";